/* eslint-disable import/no-default-export */

export default angular.module('cian.addForm.icon', []).directive('cianAfIcon', [
  '$compile',
  $compile => ({
    scope: {
      name: '@',
    },
    link(scope, element) {
      const iconWrapper = document.createElement('div');
      const iconSource = require(`./icons/${scope.name}.svg?raw`);
      iconWrapper.innerHTML = iconSource;

      const icon = iconWrapper.querySelector('svg');
      icon.setAttribute('class', `cui-icon cui-icon_${scope.name}`);

      element.html(icon.outerHTML);

      $compile(element.contents())(scope);
    },
  }),
]).name;
